import React from 'react';
import PropTypes from 'prop-types';

const XIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '20px';
  const h = (height) ? height.toString().concat('px') : '21px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 20 21"
      width={w}
      height={h}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
                // eslint-disable-next-line max-len
        d="M17.65 10.0752C17.65 14.3002 14.225 17.7252 10 17.7252C5.77502 17.7252 2.35 14.3002 2.35 10.0752C2.35 5.85022 5.77502 2.4252 10 2.4252C14.225 2.4252 17.65 5.85022 17.65 10.0752ZM19 10.0752C19 15.0458 14.9706 19.0752 10 19.0752C5.02944 19.0752 1 15.0458 1 10.0752C1 5.10463 5.02944 1.0752 10 1.0752C14.9706 1.0752 19 5.10463 19 10.0752ZM6.53168 6.60699C6.70741 6.43125 6.99234 6.43125 7.16807 6.60699L10.0001 9.43904L12.832 6.6072C13.0077 6.43147 13.2926 6.43147 13.4684 6.6072C13.6441 6.78294 13.6441 7.06786 13.4684 7.2436L10.6365 10.0754L13.4682 12.9071C13.6439 13.0828 13.6439 13.3677 13.4682 13.5435C13.2924 13.7192 13.0075 13.7192 12.8318 13.5435L10.0001 10.7118L7.16829 13.5437C6.99255 13.7194 6.70763 13.7194 6.53189 13.5437C6.35616 13.3679 6.35616 13.083 6.53189 12.9073L9.36373 10.0754L6.53168 7.24339C6.35594 7.06765 6.35594 6.78273 6.53168 6.60699Z"
        fill={(fill) || 'black'}
      />
    </svg>
  );
};

XIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default XIcon;
